import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import {
  getAllUsers,
  createUser,
  updateUser,
  deleteUser,
} from "../../../services/userServiceAdmin";

import {
  USER_INITIAL_FILTERS,
  USER_PAGE_SIZE,
} from "../../../constants/admin/user/userConstants";

export const useUserManagement = () => {
  const [users, setUsers] = useState([]);

  const [loading, setLoading] =
    useState(false);

  const [filters, setFilters] =
    useState(USER_INITIAL_FILTERS);

  const [page, setPage] = useState(1);

  const [totalPages, setTotalPages] =
    useState(1);

  const loadUsers = useCallback(
    async () => {
      try {
        setLoading(true);

        const res =
          await getAllUsers({
            page,
            limit: USER_PAGE_SIZE,
            ...filters,
          });

        setUsers(res?.data || []);

        setTotalPages(
          res?.totalPages || 1
        );
      } catch (error) {
        toast.error(
          "Không thể tải danh sách người dùng"
        );
      } finally {
        setLoading(false);
      }
    },
    [filters, page]
  );

  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  const create = async (payload) => {
    await createUser(payload);
    await loadUsers();
  };

  const update = async (
    id,
    payload
  ) => {
    await updateUser(id, payload);
    await loadUsers();
  };

  const remove = async (id) => {
    await deleteUser(id);
    await loadUsers();
  };

  return {
    users,

    loading,

    filters,
    setFilters,

    page,
    setPage,

    totalPages,

    create,
    update,
    remove,

    refresh: loadUsers,
  };
};